import Api from 'api';

import {
  GET_DISABLED_REPORT_XLSX,
  GET_DISABLED_REPORT_CSV,
  GET_DISABLED_REPORT_PDF,
  GET_DISABLED_REPORT_PAGINATED,
  SET_DISABLED_REPORT_PAGINATION,
  SET_DISABLED_REPORT_FILTERS,
  RESET_DISABLED_REPORT,
} from 'reports/constants';

export const setDisabledReportPagination = (payload) => ({
  type: SET_DISABLED_REPORT_PAGINATION,
  payload,
});

export const setDisabledReportFilters = (payload) => ({
  type: SET_DISABLED_REPORT_FILTERS,
  payload,
});

export const getDisabledReport = (
  companyId,
  subcompanyId,
  filters,
  limit,
  page,
  orderBy,
  order
) => ({
  type: GET_DISABLED_REPORT_PAGINATED,
  meta: { needAuth: true },
  payload: Api.reports.getDisabledReportPaginated(
    companyId,
    subcompanyId,
    filters,
    limit,
    page,
    orderBy,
    order
  ),
});

/**
 * @author Jorge class
 * 
 * @function getDisabledReportXLSX
 * 
 * @description This function is used to get the disabled report in XLSX format
 * 
 * @param {number} companyId
 * @param {number} subcompanyId
 * @param {object} filters
 * @returns {object}
 */
export const getDisabledReportXLSX = (companyId, subcompanyId, filters) => ({
  type: GET_DISABLED_REPORT_XLSX,
  meta: { needAuth: true },
  payload: Api.reports.getDisabledReportXLSX(companyId, subcompanyId, filters),
});

export const getDisabledReportCSV = (companyId, subcompanyId, filters) => ({
  type: GET_DISABLED_REPORT_CSV,
  meta: { needAuth: true },
  payload: Api.reports.getDisabledReportCSV(companyId, subcompanyId, filters),
});

export const getDisabledReportPDF = (companyId, subcompanyId, filters) => ({
  type: GET_DISABLED_REPORT_PDF,
  meta: { needAuth: true },
  payload: Api.reports.getDisabledReportArray(companyId, subcompanyId, filters),
});

export const resetDisabledReport = () => ({
  type: RESET_DISABLED_REPORT,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/actions/disabled_report_actions.js